import React, { Fragment } from 'react';
import { Field } from 'redux-form';

import { Anchor } from 'common';
import { Label, SubLabel, FormField, InputText } from 'common/form';

import { Icon, ActionContainer } from './styled';

const TicketFormChecklist = ({ fields }) => fields.map((field, index) => (
  <Fragment key={`${field.item}_${index}`}>
    <FormField indent>
      <Label>Checklist item omschrijving</Label>
      <SubLabel groupWithLabel>Bijvoorbeeld: vergeet uw winterbanden niet te wisselen.</SubLabel>
      <Field
        name={`${field}.item`}
        component={InputText}
        type="text"
      />

      <ActionContainer>
        {fields.length > 1 ? (
          <Anchor small onClick={() => fields.remove(index)}>
            Verwijder
          </Anchor>
        ) : (
          <Anchor
            small
            onClick={() => {
              fields.remove(index);
              fields.push({});
            }}
          >
            Leegmaken
          </Anchor>
        )}
        <Anchor small bold onClick={() => fields.push({})}>
          Voeg checklist item toe <Icon>+</Icon>
        </Anchor>
      </ActionContainer>
    </FormField>
  </Fragment>
));

export default TicketFormChecklist;
